var render = function render(){var _vm=this,_c=_vm._self._c;return _c('observability-skeleton',{ref:"observabilitySkeleton",attrs:{"variant":_vm.skeletonVariant}},[_c('iframe',{attrs:{"id":"observability-ui-iframe","data-testid":"observability-ui-iframe","frameborder":"0","width":_vm.width,"height":_vm.height,"src":_vm.iframeSrcWithParams,"sandbox":"allow-same-origin allow-forms allow-scripts"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }